import React, { useEffect, useState } from "react";
import AdminHead from "./AdminHead";
import { useParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";
import emailjs from "emailjs-com";
import Loading from "../Components/Loading";
import "../Styles/Admin/ViewOrder.css";

const EMAILJS_SERVICE_ID = "service_46i5m6n";
const EMAILJS_TEMPLATE_ID = "template_88ly4nk";
const EMAILJS_USER_ID = "ZmqOOthrLXBiLiqZ6";

function ViewOrder() {
  const { ORID } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [supplierEmail, setSupplierEmail] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const fetchOrderAndNames = async () => {
      try {
        const orderRef = doc(db, "Orders", ORID);
        const orderSnap = await getDoc(orderRef);

        if (!orderSnap.exists()) {
          setLoading(false);
          return;
        }

        const orderData = orderSnap.data();
        setOrder(orderData);
        setStatus(orderData.Status || "");

        if (orderData.CustomerID) {
          const customerRef = doc(db, "Customers", orderData.CustomerID);
          const customerSnap = await getDoc(customerRef);
          if (customerSnap.exists()) {
            setCustomerName(customerSnap.data().Name || "");
          } else {
            setCustomerName("לא נמצא לקוח");
          }
        }

        if (orderData.SapakId) {
          const supplierRef = doc(db, "Users", orderData.SapakId);
          const supplierSnap = await getDoc(supplierRef);
          if (supplierSnap.exists()) {
            const data = supplierSnap.data();
            setSupplierName(data.Name || "");
            setSupplierEmail(data.Email || "");
          } else {
            setSupplierName("לא נמצא ספק");
          }
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderAndNames();
  }, [ORID]);

  const openModal = (url) => setModalImage(url);
  const closeModal = () => setModalImage(null);

  const handleStatusChange = (e) => setStatus(e.target.value);

  const saveStatus = async () => {
    if (!order) return;
    try {
      const orderRef = doc(db, "Orders", ORID);
      await updateDoc(orderRef, { Status: status });
      setOrder((prev) => ({ ...prev, Status: status }));
      alert("סטטוס עודכן בהצלחה");

      const templateParams = {
        name: supplierName,
        email: supplierEmail || "default@supplier.com",
        ordernumber: order.orderNumber,
        status: status,
        Date: order.createdAt?.toDate().toLocaleDateString() || "",
      };

      emailjs
        .send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          templateParams,
          EMAILJS_USER_ID
        )
        .then(() => {
          console.log("Email sent to supplier.");
        })
        .catch((err) => {
          console.error("Error sending email:", err);
        });
    } catch {
      alert("שגיאה בעדכון הסטטטוס");
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "ממתין לאישור":
        return "pending";
      case "מאושר":
        return "approved";
      case "מבוטלת":
        return "rejected";
      case "סופק":
        return "delivered";
      case "נשלח":
        return "shipped";
      case "בהכנה למשלוח":
        return "preparing";
      case "נדרש תשלום":
        return "payment";
      default:
        return "default";
    }
  };

  const handlePrint = () => {
    if (!order) return;

    const typeHebrewMap = {
      Upholsterer: "ריפוד",
      Carpentry: "נגרות",
      sofa: "ספה",
      bed: "מיטה",
      closet: "ארון",
    };

    const htmlContent = `
<html dir="rtl">
<head>
  <title>הדפסת הזמנה</title>
  <style>
    body {
      font-family: 'Arial', sans-serif;
      direction: rtl;
      background-color: #fff;
      color: #000;
      margin: 20px;
    }
    h1, h2 {
      border-bottom: 2px solid #333;
      padding-bottom: 5px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    .logo { max-height: 150px; }
    .order-details { margin-bottom: 20px; }
    .status {
      font-weight: bold;
      padding: 5px 10px;
      border-radius: 5px;
      background: #f0f0f0;
      display: inline-block;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      page-break-inside: auto;
    }
    th, td {
      text-align: right;
      border: 1px solid #ccc;
      padding: 10px;
      vertical-align: top;
      word-break: break-word;
      white-space: normal;
    }
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    .full-width-row td { background: #f9f9f9; }
    img {
      max-width: 80px;
      max-height: 80px;
      margin: 4px;
    }
    .shape-img {
      max-width: 100px;
      border: 1px solid #ccc;
      margin-bottom: 10px;
    }
    .page-break {
      page-break-after: always;
      margin-bottom: 40px;
    }
    @media print {
      body { margin: 0; }
      .header { page-break-inside: avoid; }
      .page-break { page-break-after: always; }
    }
  </style>
</head>
<body>
  ${order.items
    .map(
      (item, index) => `
    <div class="page-break">
      <div class="header">
        <div>
          <h1>הזמנה מספר ${order.orderNumber} - פריט ${index + 1}</h1>
          <p class="status">סטטוס: ${order.Status}</p>
        </div>
        <div>
          <img src="https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FMilaaz1.png?alt=media&token=24f09477-3d96-4419-af28-4978ceb04997" alt="Logo" class="logo" />
        </div>
      </div>

      <div class="order-details">
        ${supplierName ? `<p><strong>שם סוכן:</strong> ${supplierName}</p>` : ""}
        ${customerName ? `<p><strong>שם לקוח:</strong> ${customerName}</p>` : ""}
        ${
          order.createdAt
            ? `<p><strong>תאריך יצירה:</strong> ${order.createdAt
                .toDate()
                .toLocaleString()}</p>`
            : ""
        }
      </div>

      <h2>פרטי מוצר</h2>
      <table>
        <thead>
          <tr>
            <th>מס'</th>
            ${item.name ? "<th>שם</th>" : ""}
            ${item.type ? "<th>סוג</th>" : ""}
            ${item.fabricManufacturer ? "<th>חברה</th>" : ""}
            ${item.fabricCode ? "<th>מספר חומר</th>" : ""}
            ${item.width ? "<th>רוחב 1</th>" : ""}
            ${item.width2 ? "<th>רוחב 2</th>" : ""}
            ${item.width3 ? "<th>רוחב 3</th>" : ""}
            ${item.height ? "<th>גובה</th>" : ""}
            ${item.depth ? "<th>עומק</th>" : ""}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            ${item.name ? `<td>${item.name}</td>` : ""}
            ${item.type ? `<td>${typeHebrewMap[item.type] || item.type}</td>` : ""}
            ${item.fabricManufacturer ? `<td>${item.fabricManufacturer}</td>` : ""}
            ${item.fabricCode ? `<td>${item.fabricCode}</td>` : ""}
            ${item.width ? `<td>${item.width} ס״מ</td>` : ""}
            ${item.width2 ? `<td>${item.width2} ס״מ</td>` : ""}
            ${item.width3 ? `<td>${item.width3} ס״מ</td>` : ""}
            ${item.height ? `<td>${item.height} ס״מ</td>` : ""}
            ${item.depth ? `<td>${item.depth} ס״מ</td>` : ""}
          </tr>
          <tr class="full-width-row">
            <td colspan="${
              2 +
              (item.name ? 1 : 0) +
              (item.type ? 1 : 0) +
              (item.fabricManufacturer ? 1 : 0) +
              (item.fabricCode ? 1 : 0) +
              (item.width ? 1 : 0) +
              (item.width2 ? 1 : 0) +
              (item.width3 ? 1 : 0) +
              (item.height ? 1 : 0) +
              (item.depth ? 1 : 0)
            }">
              ${item.description ? `<p><strong>תיאור:</strong> ${item.description}</p>` : ""}
              ${item.woodType ? `<p><strong>סוג עץ:</strong> ${item.woodType}</p>` : ""}
              ${item.notes ? `<p><strong>הערות:</strong> ${item.notes}</p>` : ""}
              ${
                item.deliveryDate
                  ? `<p><strong>תאריך אספקה:</strong> ${new Date(
                      item.deliveryDate
                    ).toLocaleDateString()}</p>`
                  : ""
              }
              ${
                item.shapeUrl
                  ? `<div><strong>צורת פריט:</strong><br><img src="${item.shapeUrl}" alt="צורת פריט" class="shape-img" /></div>`
                  : ""
              }
              ${
                item.shape2Url
                  ? `<div><strong>צורת פריט 2:</strong><br><img src="${item.shape2Url}" alt="צורת פריט 2" class="shape-img" /></div>`
                  : ""
              }
              <div>${(item.images || [])
                .map((url) => `<img src="${url}" alt="תמונה" />`)
                .join("")}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `
    )
    .join("")}

  <script>
    window.onload = function() {
      window.print();
      setTimeout(() => window.close(), 1000);
    };
  </script>
</body>
</html>
`;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  if (loading) return <Loading />;
  if (!order) return <p dir="rtl">לא נמצאה הזמנה להצגה.</p>;

  return (
    <>
      <AdminHead />
      <div className="view-order-container" dir="rtl" style={{ padding: "20px" }}>
        <h1>פרטי הזמנה</h1>
        <p>
          <strong>מספר הזמנה:</strong> {order.orderNumber}
        </p>

        <p>
          <strong>סטטוס:</strong>{" "}
          <select
            value={status}
            onChange={handleStatusChange}
            className={getStatusClass(status)}
          >
            <option value="">בחר סטטוס</option>
            <option value="ממתין לאישור">ממתין לאישור</option>
            <option value="מאושר">מאושר</option>
            <option value="מבוטלת">מבוטלת</option>
            <option value="סופק">סופק</option>
            <option value="נשלח">נשלח</option>
            <option value="בהכנה למשלוח">בהכנה למשלוח</option>
            <option value="נדרש תשלום">נדרש תשלום</option>
          </select>
          <button
            className="save-status-btn"
            onClick={saveStatus}
            style={{ marginLeft: 10 }}
          >
            שמור
          </button>
        </p>

        <p>
          <strong>תאריך יצירה:</strong> {order.createdAt?.toDate().toLocaleString()}
        </p>
        <p>
          <strong>שם סוכן:</strong>
          <em> {supplierName}</em>
        </p>
        <p>
          <strong>שם לקוח:</strong>
          <em> {customerName}</em>
        </p>

        <button onClick={handlePrint} className="print-order-btn">
          הדפס הזמנה
        </button>

        {order.items &&
          order.items.map((item, index) => (
            <div key={index} className="sview-item">
              {item.name && (
                <p>
                  <span className="sview-label">שם פריט:</span> {item.name}
                </p>
              )}
              {item.description && (
                <p>
                  <span className="sview-label">תיאור:</span> {item.description}
                </p>
              )}
              {item.type && (
                <p>
                  <span className="sview-label">סוג:</span> {item.type}
                </p>
              )}
              {item.fabricCode && (
                <p>
                  <span className="sview-label">קוד בד:</span> {item.fabricCode}
                </p>
              )}
              {item.fabricManufacturer && (
                <p>
                  <span className="sview-label">יצרן בד:</span>{" "}
                  {item.fabricManufacturer}
                </p>
              )}
              {item.woodType && (
                <p>
                  <span className="sview-label">סוג עץ:</span> {item.woodType}
                </p>
              )}
              {item.width !== undefined && item.width !== "" && (
                <p>
                  <span className="sview-label">רוחב 1:</span> {item.width} ס״מ
                </p>
              )}
              {item.width2 !== undefined && item.width2 !== "" && (
                <p>
                  <span className="sview-label">רוחב 2:</span> {item.width2} ס״מ
                </p>
              )}
              {item.width3 !== undefined && item.width3 !== "" && (
                <p>
                  <span className="sview-label">רוחב 3:</span> {item.width3} ס״מ
                </p>
              )}
              {item.height !== undefined && item.height !== "" && (
                <p>
                  <span className="sview-label">גובה:</span> {item.height} ס״מ
                </p>
              )}
              {item.depth !== undefined && item.depth !== "" && (
                <p>
                  <span className="sview-label">עומק:</span> {item.depth} ס״מ
                </p>
              )}
              {item.notes && (
                <p>
                  <span className="sview-label">הערות:</span> {item.notes}
                </p>
              )}
              {item.deliveryDate && (
                <p>
                  <span className="sview-label">תאריך אספקה:</span>{" "}
                  {new Date(item.deliveryDate).toLocaleDateString()}
                </p>
              )}

              {item.shapeUrl && (
                <div className="sview-shape">
                  <p>
                    <strong>צורת פריט:</strong>
                  </p>
                  <img
                    src={item.shapeUrl}
                    alt="צורת פריט"
                    style={{
                      maxWidth: "100px",
                      border: "1px solid #ccc",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              )}

              {item.shape2Url && (
                <div className="sview-shape">
                  <p>
                    <strong>צורת פריט 2:</strong>
                  </p>
                  <img
                    src={item.shape2Url}
                    alt="צורת פריט 2"
                    style={{
                      maxWidth: "100px",
                      border: "1px solid #ccc",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              )}

              {item.images && item.images.length > 0 && (
                <div className="sview-images">
                  {item.images.map((url, i) => (
                    <img
                      key={i}
                      src={url}
                      alt={`תמונה ${i + 1} של פריט ${index + 1}`}
                      onClick={() => openModal(url)}
                      style={{
                        cursor: "pointer",
                        maxWidth: "100px",
                        marginRight: "8px",
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          ))}
      </div>

      {/* ✅ FIXED MODAL */}
      {modalImage && (
        <div className="modal-backdrop" onClick={closeModal}>
          {/* stop click bubbling so image click doesn't close instantly */}
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={modalImage} alt="תמונה מוגדלת" />
          </div>
        </div>
      )}
    </>
  );
}

export default ViewOrder;
